<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('masterdata')"
          :directory="$t('editar banco')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <a href="/masterdata/banks" class="btn btn-primary">Volver</a>
        </div>
      </div>
    </div>

    <div class="card card-with-shadow border-0 mb-primary">
      <div class="card-body">
        <form ref="form" class="mb-0" :class="{ 'loading-opacity': preloader }">
          <fieldset class="form-group">
            <div class="card card-with-shadow border-0 mb-primary">
              <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">Información del banco</h5>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("Nombre del banco") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.name"
                    :required="true"
                    :read-only="false"
                    :placeholder="$t('Ingrese el nombre del banco')"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("N° de cuenta") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.account_number"
                    :required="true"
                    :read-only="false"
                    :placeholder="$t('Ingrese el número de cuenta')"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("Sublinea") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.subline"
                    :required="true"
                    :read-only="false"
                    :placeholder="$t('type_social_reason')"
                  />
                </div>
              </div>

              <!-- <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("social_reason") }}</label>
                  <app-input
                    type="select"
                    v-model="inputs.is_active"
                    :required="true"
                    :read-only="false"
                    :placeholder="$t('Seleccionar estado')"
                  />
                </div>
              </div> -->
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../apiUrl";

export default {
  name: "Form",
  mixins: [FormMixin],
  props: {
    Id: String,
    backUrl: {
      type: String,
      default: "/",
    },
  },
  data() {
    return {
      url: "",
      preloader: false,
      rucFile: "Seleccionar Archivo",
      taxidFile: "Seleccionar Archivo",
      legalRepFile: "Seleccionar Archivo",
      agreementFile: "Seleccionar Archivo",
      selectedSocietyType: "",
      inputs: {},
      kindOfSocietyLists: [
        { id: "private", value: "Sociedad Privada" },
        { id: "public", value: "Sociedad Pública" },
      ],
    };
  },
  created() {
    this.$store.state.Id = this.Id;
    this.data();
  },
  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    data() {
      this.preloader = true;
      let url = `${actions.MASTERDATA}/get_id/${this.Id}`;
      this.axiosGet(url)
        .then((response) => {
          console.log(response.data[0].name);
          if (response.status == 200) {
            this.inputs.name = response.data[0].name;
            this.inputs.account_number = response.data[0].account_number;
            this.inputs.subline = response.data[0].subline;
            this.inputs.is_active = response.data[0].is_active;
            
          }
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>